import { Either, Left } from 'fp-ts/lib/Either'

import Parameter, { CreateParameterError } from './parameter'
import Constant from './type/constant'
import UserSelect from './type/user-select'
import Variable from './type/variable'

export default class ParameterFactory {

  constructor(
    private raw: any
  ) {}

  create(): Either<Error, Parameter> {
    const type = this.raw.type

    if (type === 'constant') {
      return Constant.createFromApiResponse(this.raw)
    }
    if (type === 'variable') {
      return Variable.createFromApiResponse(this.raw)
    }
    if (type === 'user_select') {
      return UserSelect.createFromApiResponse(this.raw)
    }

    return new Left(new CreateParameterError(`Unexpected type error.`))
  }
}
